import { createContext } from 'react';

export interface WidgetActiveSlideContextType {
  widgetActiveSlide: number;
  setWidgetActiveSlide: React.Dispatch<React.SetStateAction<number>>;
}

export const WidgetActiveSlideContext = createContext<WidgetActiveSlideContextType | undefined>(undefined);
